<template>
  <section id="kv" class="section" :class="{ play: isInView }">
    <div class="section__content">
      <div class="wrap">
        <div class="block-group">
          <div class="block-group__item"></div>
          <div class="block-group__item"></div>
          <div class="block-group__item"></div>
          <div class="block-group__item"></div>
          <div class="block-group__item"></div>
        </div>
        <!-- <div class="kv-title">
          <p class="kv-title__sub">法盛盧米斯賽勒斯</p>
          <p class="kv-title__sub">
            <span class="highlight">美國成長</span>股票基金
          </p>
        </div> -->
        <div class="kv-title">
          <!-- <img src="../assets/images/kv_title.png" alt="" /> -->
        </div>
        <div class="text-box">
          <div class="text-box__item">
            <div class="text-box__list">
              <p class="text-box__list--text">精準出擊</p>
            </div>
            <div class="text-box__list">
              <p class="text-box__list--text">贏在成長</p>
            </div>
          </div>
        </div>
        <div class="kv-img__item">
          <div
            class="kv-img__list"
            :class="{
              'animate__animated animate__fadeInUp custom-duration custom-timing':
                isInView,
            }"
          >
            <img src="../assets/images/kv_img-1.png" alt="" />
          </div>
          <!-- <div
            class="kv-img__list"
            :class="{
              'animate__animated animate__fadeInUp custom-duration custom-timing animate__delay-02s ':
                isInView,
            }"
          >
            <img src="../assets/images/kv_img-2.png" alt="" />
          </div> -->
        </div>
        <div class="scroll-icon"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'Kv',
  props: {},
  watch: {
    isLoading() {
      this.init();
    },
    isInView(newVal) {
      if (newVal) {
        console.log('play');
      }
    },
  },
  data: () => {
    return {
      isInView: false,
    };
  },
  computed: {
    ...mapState(useMainStore, ['isLoading']),
  },
  methods: {
    // ...mapActions([]),
    init() {
      this.isInView = true;
    },
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
$assets: '~@/assets/images/kv/';

#kv {
  width: 100%;
  max-width: 1920px;
  height: calc(1076px * 0.8);
  background-image: url('../assets/images/kv_bg.jpg');
  background-size: calc(2500px * 0.8) calc(1076px * 0.8);
  background-position: center bottom;
  padding-top: calc(295px * 0.8);
  @include tabletX {
    // background-size: calc(vwX(2500) * 0.8) calc(vwX(1076) * 0.8);
    // padding-top: calc(vwX(295) * 0.8);
    padding-top: calc(295px * 0.8);
  }
  @include tablet {
    overflow: hidden;
    width: 100%;
    height: 0;
    padding-bottom: 133%;
    // height: vwM(1732);
    background-image: url('../assets/images/kv_bg_m.jpg');
    background-repeat: no-repeat;
    background-size: vwM(1080) vwM(1732);
    background-position: center top;
    position: relative;
    padding-top: vwM(210);
  }
  @include mobile {
    padding-bottom: 131%;
  }
  .section__content {
    .block-group__item {
      width: 38px;
      height: 38px;
      position: absolute;
      @include tablet {
        width: vwM(45);
        height: vwM(45);
      }
      &:nth-child(1) {
        background-color: #009bb1;
        top: -83px;
        left: 804px;
        animation: fadeBlock 3s infinite reverse;
        @include tabletX {
          top: 0%;
          left: 56%;
        }
        @include tablet {
          background-color: #ccecf0;
          top: vwM(275);
          left: vwM(349);
        }
        @include mobile {
          left: 33%;
        }
      }
      &:nth-child(2) {
        background-color: #64117d;
        top: 344px;
        left: 1310px;
        animation: fadeBlock 3.5s 0.8s infinite reverse;
        @include tabletX {
          top: 43%;
          left: 91.5%;
        }
        @include tablet {
          background-color: #e0cfe5;
          top: vwM(460);
          left: vwM(996);
        }
        @include mobile {
          left: 93%;
        }
      }
      &:nth-child(3) {
        background-color: #95d4dc;
        top: 812px;
        left: -53px;
        z-index: 2;
        animation: fadeBlock 3s 0.4s infinite reverse;
        @include tablet {
          background-color: #ccecf0;
          top: vwM(552);
          left: vwM(903);
        }
        @include mobile {
          left: 87%;
        }
      }
      &:nth-child(4) {
        background-color: #ba9ac6;
        top: 889px;
        left: 1348px;
        z-index: 2;
        animation: fadeBlock 4s 1s infinite reverse;
        @include tabletX {
          top: 116%;
          left: 97%;
        }
        @include tablet {
          background-color: #c1a0cb;
          top: vwM(598);
          left: vwM(212);
        }
        @include mobile {
          left: 20.3%;
        }
      }
      &:nth-child(5) {
        background-color: #95d3dc;
        top: 1083px;
        left: -92px;
        z-index: 2;
        animation: fadeBlock 3.8s 0.75s infinite reverse;
        @include mobile {
          display: none;
        }
      }
    }
    .wrap {
      margin: -68px auto 0 auto;
      @include tablet {
        width: 100%;
        height: vwM(1723);
        margin: 0 auto;
      }
    }
    .kv-title {
      width: 825px;
      height: 200px;
      background-image: url('../assets/images/kv_title.png');
      background-repeat: no-repeat;
      background-size: 825px 200px;
      background-position: center top;
      position: relative;
      top: -31px;
      left: -14px;
      @include tabletX {
        width: vwX(825);
        height: vwX(200);
        background-size: vwX(825) vwX(200);
        top: vwX(-31);
        left: vwX(-14);
      }
      @include tablet {
        width: vwM(648);
        height: vwM(193);
        background-image: url('../assets/images/kv_title_m.png');
        background-size: vwM(648) vwM(193);
        position: relative;
        top: vwM(32);
        left: vwM(66);
      }
    }
    .kv-title__sub {
      font-size: 58px;
      line-height: lineHeight(58, 80);
      letter-spacing: letterSpacing(160, 58px);
      font-weight: 500;
      @include tabletX {
        font-size: vwX(58);
        letter-spacing: letterSpacing(160, vwX(58));
      }
      @include tablet {
        font-size: vwM(70);
        line-height: lineHeight(58, 90);
        letter-spacing: letterSpacing(160, vwM(70));
      }
      .highlight {
        color: #64117d;
      }
    }
    .kv-img__item {
      .kv-img__list:nth-child(1) {
        width: 1160px;
        height: 510px;
        position: absolute;
        top: 0px;
        right: -75px;
        // left: 0;
        opacity: 1;
        @include tabletX {
          width: vwX(1100);
          height: vwX(510);
          top: 10px;
          right: -95px;
        }
        @include tablet {
          width: vwM(951);
          height: vwM(395);
          top: vwM(215);
          right: vwM(100);
        }
      }
      .kv-img__list:nth-child(2) {
        width: 634px;
        height: 1089px;
        position: absolute;
        top: 58px;
        right: 234px;
        z-index: 2;
        opacity: 0;
        @include tabletX {
          // width: vwX(634);
          // height: vwX(1089);
          // top: vwX(58);
          width: 600px;
          height: 1031px;
          top: 117px;
          right: vwX(234);
        }
        @include tablet {
          width: vwM(566);
          height: vwM(972);
          top: vwM(243);
          right: vwM(237);
          z-index: 0;
        }
      }
      img {
        width: 100%;
        // @include desktop {
        //   width: auto;
        // }
      }
    }

    .text-box {
      margin: 42px 0 0 63px;
      @include tabletX {
        margin: 42px 0 0 0;
      }
      @include tablet {
        position: relative;
        z-index: 2;
        margin: vwM(825) 0 0 vwM(70);
      }
    }
    .text-box__item {
      display: flex;
      justify-self: flex-start;
      align-items: flex-start;
      position: relative;
    }
    .text-box__list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 319px;
      height: 319px;
      color: #fff;
      @include tabletX {
        width: vwX(319);
        height: vwX(319);
      }
      @include tablet {
        width: vwM(368);
        height: vwM(368);
      }
    }
    .text-box__list:nth-child(1) {
      background-color: #0099af;
      margin-top: 179px;
      @include tabletX {
        margin-top: vwX(179);
      }
      @include tablet {
        margin-top: vwM(0);
      }
    }
    .text-box__list:nth-child(2) {
      background-color: #5f1077;
      &::after {
        display: block;
        content: '';
        width: 55px;
        height: 55px;
        background-image: url('../assets/images/cross_icon.png');
        background-repeat: no-repeat;
        background-position: center top;
        background-size: 55px 55px;
        position: absolute;
        top: 149px;
        left: 292px;
        z-index: 1;
        @include tabletX {
          width: vwX(55);
          height: vwX(55);
          background-size: vwX(55) vwX(55);
          top: 30.5%;
          left: 46%;
        }
        @include tablet {
          width: vwM(65);
          height: vwM(65);
          background-size: vwM(65) vwM(65);
          top: vwM(-32);
          left: vwM(336);
        }
      }
    }
    .text-box__list--text {
      font-size: 53px;
      letter-spacing: letterSpacing(160, 53px);
      font-weight: 400;
      @include tabletX {
        font-size: vwX(53);
        letter-spacing: letterSpacing(160, vwX(53));
      }
      @include tablet {
        font-size: vwM(70);
        letter-spacing: letterSpacing(160, vwM(70));
      }
    }

    .scroll-icon {
      width: 42px;
      height: 42px;
      background-image: url('../assets/images/scroll_icon.png');
      background-repeat: no-repeat;
      background-size: 42px 42px;
      background-position: center top;
      position: absolute;
      top: 755px;
      left: calc(50% - (42px / 2));
      z-index: 2;
      animation: scrollArrow 1.5s infinite linear;
      @include tablet {
        width: vwM(63);
        height: vwM(63);
        background-size: vwM(63) vwM(63);
        top: vwM(883);
        left: calc(50% - vwM(63) / 2);
      }
    }
  }

  @keyframes scrollArrow {
    0% {
      transform: translateY(-15%);
    }
    50% {
      transform: translateY(15%);
    }
    100% {
      transform: translateY(-15%);
    }
  }

  @keyframes fadeBlock {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
